import { Table } from 'antd';
import {
	ApplicationsFilter,
	FunctionaryInfo,
	Pagination,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { tablePaginationConfiguration } from '../../../shared/Utils';
import { FunctionaryTableColumns } from './FunctionaryTableColumns';
import { NavigateOptions } from 'react-router-dom';

interface FunctionaryTableProps {
	functionaries: FunctionaryInfo[] | undefined;
	pagination: Pagination;
	paging: PagingConfig;
	onPageChange: (page: number, pageSize: number) => void;
	navigateWithFunctionarySrcmId: (
		route: string,
		functionarySIdParam?: string,
		params?: NavigateOptions
	) => void;
	onFilterChange: (filterParam: ApplicationsFilter) => void;
}

export const FunctionaryTableView = (props: FunctionaryTableProps) => {
	const {
		functionaries,
		paging,
		pagination,
		onPageChange,
		navigateWithFunctionarySrcmId,
		onFilterChange,
	} = props;

	const tablePaginationConfig = tablePaginationConfiguration(
		paging,
		pagination,
		onPageChange
	);

	const columns = FunctionaryTableColumns({
		navigateWithFunctionarySrcmId,
		onFilterChange,
	});

	return (
		<>
			<>
				<Table
					columns={columns}
					dataSource={functionaries}
					pagination={tablePaginationConfig}
					scroll={{ x: 'max-content' }}
					rowClassName={() => 'border-b border-gray-300 bg-white'}
					className="w-full overflow-x-auto !border-separate !border-spacing-y-0"
				/>
			</>
		</>
	);
};
